import React from "react";
import { Link } from "react-router-dom";

interface IFindJobContent {
  title: string;
  description: string;
  buttonContent: string;
  buttonUrl?: string;
  underlineUrl?: string;
}

const FindJobLayout = ({
  title,
  description,
  buttonContent,
  buttonUrl,
  underlineUrl,
}: IFindJobContent) => {
  return (
    <div
      className="p-5 sm:p-10 sm:px-16 md:px-20 lg:px-36"
      style={{
        backgroundImage: "url('/home/early-access-bg.svg')",
      }}
    >
      <div className="flex flex-col md:flex-row gap-5 md:gap-32">
        <div className="flex justify-center items-center">
          <img
            src="/aboutus/hands.png"
            alt=""
            className="h-48 sm:h-56 md:h-[19rem]"
          />
        </div>
        <div className="flex-1 md:py-10 flex flex-col gap-3 md:gap-8 md:justify-start">
          <h3
            className="text-xl text-white text-center md:text-left 
      sm:text-2xl md:text-3xl lg:text-4xl xl:text-[3rem] 
      leading-normal sm:leading-normal md:leading-relaxed 
      lg:leading-tight tracking-normal font-normal"
          >
            {title}
          </h3>
          <p className="text-sm sm:text-base md:text-lg text-center md:text-left text-neutral-400 font-light w-full max-w-6xl xl:text-2xl">
            {description}
          </p>
          <div className="flex justify-center mt-2 md:mt-0 md:justify-start">
            <div className="flex flex-col md:flex-row justify-center gap-6 items-center">
              <div>
                {buttonUrl ? (
                  <Link to={buttonUrl}>
                    <button className="w-fit px-4 py-2 text-xs sm:text-sm hover:bg-opacity-90 transition-all duration-200 ease-out bg-[#00BB68] text-white rounded-full">
                      {buttonContent}
                    </button>
                  </Link>
                ) : (
                  <button className="w-fit px-4 py-2 text-xs sm:text-sm bg-[#00BB68] text-white rounded-full">
                    {buttonContent}
                  </button>
                )}
              </div>
              <div>
                {/* todo: change the url heer */}
                <Link
                  to={underlineUrl ? underlineUrl : "/"}
                  className="text-sm underline text-white flex justify-center items-center"
                >
                  Find Job Positons
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindJobLayout;
